import { render } from "./TeamLeadReport.vue?vue&type=template&id=83f447d4&scoped=true"
import script from "./TeamLeadReport.vue?vue&type=script&lang=js"
export * from "./TeamLeadReport.vue?vue&type=script&lang=js"

import "./TeamLeadReport.vue?vue&type=style&index=0&id=83f447d4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f447d4"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect,QBtn});
